<p8-layout-settings-page>
  <div fxLayoutAlign="end end" fxLayout="row">
    <button mat-raised-button color="primary" align="end"
            (click)="exportPdfForm(formModel)"
    >Imprimer ce formulaire</button>
  </div>
  <div class="render__form" fxLayoutAlign="space-around center" fxLayout="column">
    <mat-card *ngIf="blockType === blockTypeEnum.Public" class="mat-elevation-z3 top__form">
      <mat-card-title fxLayoutAlign="center">
        <div class="form__title">
          {{formModel?.nom}}
        </div>
      </mat-card-title>
      <mat-card-subtitle fxLayoutAlign="center" class="form__sub__title" *ngIf="formModel?.description">
        {{formModel?.description}}
      </mat-card-subtitle>
    </mat-card>
    <mat-card class="mat-elevation-z2" style="width: 70%">
      <mat-card-content>
        <mat-expansion-panel *ngIf="formModel['attachments_obj'] && formModel['attachments_obj'].length > 0">
          <mat-expansion-panel-header>
            <mat-panel-description>
              {{formModel?.titre_documents || 'Documents associés au formulaire'}}
              (télécharger le Zip
              <button mat-icon-button
                      color="accent"
                      class="file__icon"
                      (click)="exportZipAttachementsForm(formModel)"
                      data-cy="button-form-render-folder-zip"
              >
                <mat-icon data-cy="icon-form-render-folder-zip">folder_zip</mat-icon>
              </button>
              )
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="attachements">
            <mat-list>
              <ng-container *ngFor="let f of formModel['attachments_obj']; let idx = index">
                <mat-list-item class="file__list">
                  <div style="margin-right: 10px;">{{f.name}}</div>
                  <mat-icon color="accent" style="cursor: pointer;"
                            [matTooltip]="'Télécharger ' + f?.name"
                            (click)="downloadSelectedFile(f)"
                            data-cy="button-form-render-folder-download"
                            >download</mat-icon>
                </mat-list-item>
              </ng-container>
            </mat-list>
          </div>
        </mat-expansion-panel>
        <!-- pastille état instruction et message le cas échéant -->
        <div *ngIf="userResponse" fxLayoutAlign="end">
          <span [innerHTML]="stateResponseChip(userResponse)"
                *ngIf="userResponse?.state === reponseState.draft"></span>
          <span [innerHTML]="stateInstructionChip(userResponse)"
                *ngIf="userResponse?.last_instruction_obj?.state === lastInstructionState.incomplete"></span>
        </div>
        <app-motif-message-response [response]="userResponse"></app-motif-message-response>
        <div>
          <p *ngIf="reference && !userAlreadyRespondToSurvey">Référence de la demande : {{ reference }}</p>
          <p align="end" *ngIf="blockType === blockTypeEnum.Public" style="font-size: 12px;">
            <span class="mandatory-field">* champs obligatoires pour envoyer la demande</span>
          </p>
        </div>
        <div *ngIf="userAlreadyRespondToSurvey">
          <p align="center" style="color: firebrick">
            Vous avez déja repondu a ce sondage.
          </p>
          <p>Référence de la demande : {{ userResponse?.reference }}</p>
          <p>
            Lien vers votre réponse.
            <button
              mat-icon-button
              matTooltip="Lien vers ma réponse"
              color="accent"
              (click)="visualize(userResponse)"
              data-cy="button-form-render-link"
            >
              <mat-icon data-cy="icon-form-render-open-in-new">open_in_new</mat-icon>
            </button>
          </p>
        </div>
        <div align="center" *ngIf="checkIfSondageIsOver()">
          <p style="color: firebrick">
            Ce sondage est terminé.
          </p>
        </div>
        <form [formGroup]="filterForm" class="dm__form">
          <ng-template #recursiveList let-blocks let-fromGroup="fromGroup">
            <ng-container *ngFor="let item of blocks; let idx = index">
              <!-- bloc -->
              <ng-container *ngIf="item.fields_objs; else default;">
                <div class="block__container">
                  <div *ngIf="item.nom" class="block__title">
                    <h2><span>{{ getBlockPrefixDesign(idx) }}</span> {{item.nom}}</h2>
                  </div>
                  <mat-card class="mat-elevation-z0 block__card">
                    <div *ngIf="item?.condition_obj?.is_active">
                      <label>{{item?.condition_obj?.condition}}</label>
                      <mat-radio-group [formControlName]="formCondtionBlockName(item.key)" class="block__condition">
                        <mat-radio-button [value]="true">{{item?.condition_obj?.satisfy}}</mat-radio-button>
                        <mat-radio-button [value]="false">{{item?.condition_obj?.other}}</mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <ng-container *ngIf="displayBlock(item.key)">
                      <ng-container
                        *ngTemplateOutlet="recursiveList; context:{ $implicit: sortFields(item.fields_objs), fromGroup: {name: item.key} }">
                      </ng-container>
                    </ng-container>
                  </mat-card>
                </div>
              </ng-container>
              <!-- champs -->
              <ng-template #default>
                <!-- item.key : key = field id -->
                <div [formGroupName]="fromGroup.name"
                     [ngSwitch]="item.options_obj.controlType"
                     class="fields__container">
                  <!-- Field Text -->
                  <div *ngSwitchCase="fieldType.TypeText" class="field__box" fxLayout="column">
                    <app-form-render-label [item]="item"></app-form-render-label>
                    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                      <input
                        [formControlName]="item.key"
                        [matTooltip]="item.options_obj.tooltip"
                        [placeholder]="item.options_obj.placeholder"
                        [required]="item.options_obj.isRequired"
                        [type]="item.options_obj.controlType"
                        matInput
                        [minlength]="constants.MIN_TEXT_LENGTH">
                      <div *ngIf="fieldControl(item.block, item.key)['showErrMsg']">
                        <mat-error>
                          {{getErrorMessage(item.block, item.key)}}
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>

                  <!-- Field Label -->
                  <div *ngSwitchCase="fieldType.TypeLabel" class="field__box" fxLayout="column">
                    <app-form-render-label [item]="item"></app-form-render-label>
                    <div class="qll-label" [innerHTML]="sanitizer.bypassSecurityTrustHtml(item.options_obj.content ?? '')"></div>
                  </div>

                  <!-- Field Text Area -->
                  <div *ngSwitchCase="fieldType.TypeTextarea" class="field__box" fxLayout="column">
                    <app-form-render-label [item]="item"></app-form-render-label>
                    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                        <textarea
                          [formControlName]="item.key"
                          [matTooltip]="item.options_obj.tooltip"
                          [placeholder]="item.options_obj.placeholder"
                          [required]="item.options_obj.isRequired"
                          [type]="item.options_obj.controlType"
                          matInput
                          [minlength]="constants.MIN_TEXT_LENGTH"
                          [attr.data-cy]="'txtarea-form-render-'+item.id"
                        >
                        </textarea>
                      <div *ngIf="fieldControl(item.block, item.key)['showErrMsg']">
                        <mat-error>
                          {{getErrorMessage(item.block, item.key)}}
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                  <!-- Field Date -->
                  <div *ngSwitchCase="fieldType.TypeDate" class="field__box" fxLayout="column">
                    <app-form-render-date [formGroup]="filterForm" [item]="item"></app-form-render-date>
                  </div>
                  <!-- Field Phone -->
                  <div *ngSwitchCase="fieldType.TypePhone" class="field__box" fxLayout="column">
                    <app-form-render-label [item]="item"></app-form-render-label>
                    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                      <input
                        (keydown)="onKeyDownPhone(item.block, item.key, $event)"
                        (keyup)="onKeyUpPhone(item.block, item.key, $event)"
                        (paste)="onPastePhone(item.block, item.key, $event)"
                        [formControlName]="item.key"
                        [matTooltip]="item.options_obj.tooltip"
                        [placeholder]="item.options_obj.placeholder"
                        [required]="item.options_obj.isRequired || false"
                        matInput
                        maxlength="10"
                        type="text"

                      >
                      <div *ngIf="fieldControl(item.block, item.key)['showErrMsg']">
                        <mat-error>
                          {{getErrorMessage(item.block, item.key)}}
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                  <!-- Field Email -->
                  <div *ngSwitchCase="fieldType.TypeEmail" class="field__box" fxLayout="column">
                    <app-form-render-label [item]="item"></app-form-render-label>
                    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                      <input
                        [formControlName]="item.key"
                        [matTooltip]="item.options_obj.tooltip"
                        [placeholder]="item.options_obj.placeholder"
                        [required]="item.options_obj.isRequired || false"
                        matInput
                        type="text"
                      >
                      <div *ngIf="fieldControl(item.block, item.key)['showErrMsg']">
                        <mat-error>
                          {{getErrorMessage(item.block, item.key)}}
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                  <!-- Field checkbox -->
                  <div *ngSwitchCase="fieldType.TypeCheckbox" class="field__box ckbox" fxLayout="column">
                    <app-form-render-label [item]="item"></app-form-render-label>
                    <div [formArrayName]="item.key">
                      <ng-container *ngFor="let option of item.options_obj.options; let i = index" [formGroupName]="i">
                        <mat-checkbox [class.horizontal]="item.options_obj.horizontal"
                                      aria-label="Sélectionner un ou plusieurs choix"
                                      class="item" formControlName="value" [attr.data-cy]="'chkbx-form-render-'+item.options_obj.id">
                          {{option.key}}
                        </mat-checkbox>
                      </ng-container>
                      <div *ngIf="fieldControl(item.block, item.key)['showErrMsg']">
                        <mat-error>
                          {{getErrorMessage(item.block, item.key)}}
                        </mat-error>
                      </div>
                    </div>

                  </div>
                  <!-- Field radio  -->
                  <div *ngSwitchCase="fieldType.TypeRadio" class="field__box" fxLayout="column">
                    <app-form-render-label [item]="item"></app-form-render-label>
                    <div>
                      <mat-radio-group [formControlName]="item.key" aria-label="Sélectionner un choix">
                        <ng-container *ngIf="!item.options_obj.isRequired">
                          <mat-radio-button [value]="nullValues.Radio.value" class="item"
                                            [class.horizontal]="item.options_obj.horizontal">
                            {{nullValues.Radio.render}}
                          </mat-radio-button>
                        </ng-container>

                        <ng-container *ngFor="let option of item.options_obj.options; let i = index">
                          <mat-radio-button [value]="option.key" class="item"
                                            [class.horizontal]="item.options_obj.horizontal">
                            {{option.key}}
                          </mat-radio-button>
                        </ng-container>
                        <div *ngIf="fieldControl(item.block, item.key)['showErrMsg']">
                          <mat-error>
                            {{getErrorMessage(item.block, item.key)}}
                          </mat-error>
                        </div>
                      </mat-radio-group>
                    </div>
                  </div>
                  <!-- Field liste   -->
                  <div *ngSwitchCase="fieldType.TypeSelect" class="field__box" fxLayout="column">
                    <app-form-render-label [item]="item"></app-form-render-label>
                    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
                      <mat-select [formControlName]="item.key" placeholder="{{item.options_obj.placeholder}}" [attr.data-cy]="'select-form-render-'+item.id">
                        <ng-container *ngIf="!item.options_obj.isRequired">
                          <mat-option [value]="nullValues.List.value" data-cy="option-form-render-list">
                            {{nullValues.List.render}}
                          </mat-option>
                        </ng-container>
                        <mat-option *ngFor="let option of item.options_obj.options" [value]="option.key" [attr.data-cy]="'option-form-render-'+item.id">
                          {{option.key}}
                        </mat-option>
                      </mat-select>
                      <div *ngIf="fieldControl(item.block, item.key)['showErrMsg']">
                        <mat-error>
                          {{getErrorMessage(item.block, item.key)}}
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                  <!-- Field services/composantes   -->
                  <div *ngSwitchCase="fieldType.TypeSvcCmp" class="field__box" fxLayout="column">
                    <app-form-render-svccmp  [formGroup]="filterForm" [item]="item"></app-form-render-svccmp>
                  </div>
                  <!-- Field avis   -->
                  <div *ngSwitchCase="fieldType.TypeAvis" class="field__box" fxLayout="column">
                    <app-form-render-avis [item]="item" [formGroup]="filterForm"></app-form-render-avis>
                  </div>
                  <!-- Field File   -->
                  <div *ngSwitchCase="fieldType.TypeFile" class="field__box" fxLayout="column">
                    <div fxLayout="column" fxLayoutAlign="space-between stretch">
                      <app-form-render-label [item]="item"></app-form-render-label>
                      <fieldset class="fieldset">
                        <div class="fieldset__content" fxLayout="row" fxLayoutGap="15px">
                          <div fxFlex>
                            <mat-list>
                              <ng-container *ngIf="validateFile(fileInput.files[0]) || checkIfValueFileExist(item)">
                                <mat-list-item style="height: 30px;" >
                                  <span style="display: flex; align-items: center;">
                                    <mat-icon mat-list-icon
                                              *ngIf="showClearBtn(item)"
                                              color="primary"
                                              style="cursor: pointer"
                                              [matTooltip]="'Supprimer ' + (findResponseField(item)?.value || fileInput.files[0].name)"
                                              (click)="clearSelectedFile(item)"
                                              data-cy="icon-form-render-clear"
                                    >
                                    delete_outline</mat-icon>
                                  <div class="fieldset__name__file" mat-line>
                                    <input style="border: none;" matInput [formControlName]="item.key" readonly/>
                                  </div>
                                  </span>
                                </mat-list-item>
                              </ng-container>

                            </mat-list>

                          </div>

                          <div fxFlex="45" fxLayoutAlign="end center">
                            <button (click)="fileInput.click()" data-cy="button-form-render-browse" mat-raised-button>
                              <mat-icon>attach_file</mat-icon>
                              <span>parcourir </span>
                              <input #fileInput
                                     (change)="handleFileInputChange(fileInput.files[0], item)"
                                     [accept]="item.options_obj.acceptedTypeFile"
                                     [multiple]="item.options_obj.multiple"
                                     [id]="item.key"
                                     hidden
                                     type="file"
                              />
                            </button>
                            <button  *ngIf="(blockType === blockTypeEnum.Administratif)
                                                 && findResponseField(item)?.value
                                                 &&  findResponseField(item)?.file"
                                     (click)="downloadFile(findResponseField(item))"
                                     mat-mini-fab style="margin-left: 5px"
                                     color="accent"
                                     [matTooltip]="'Télécharger le fichier ' + findResponseField(item)?.value"
                                     data-cy="button-form-render-download"
                            >
                              <mat-icon>file_download</mat-icon>
                            </button>
                          </div>
                        </div>
                      </fieldset>
                      <div *ngIf="isUploading(item)" data-cy="progress-form-render-upload" style="margin: 2px 0 6px;">
                        <mat-progress-bar [mode]="uploadPercent(item) < 100 ? 'determinate' : 'indeterminate'"
                                          [value]="uploadPercent(item)"></mat-progress-bar>
                        <div fxLayout="row" fxLayoutAlign="space-between center"
                             style="margin-top: 4px; font-size: 13px; font-weight: 500;">
                          <span>Envoi du fichier en cours, veuillez patienter et ne pas quitter la page…</span>
                          <span>{{uploadPercent(item)}} %</span>
                        </div>
                      </div>
                      <p class="fieldset__helper">{{constants.messages.maxSizeFileInfo}}</p>
                      <p class="fieldset__helper" *ngIf="fieldControl(item.block, item.key)['showErrMsg']" style="color: firebrick">
                        {{getErrorMessage(item.block, item.key)}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </ng-template>
          <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: blocks }"></ng-container>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <p8-layout-settings-footer *ngIf="canSave" [flexLayoutAlign]="'end'">
    <!-- formulaire rempli par le demandeur -->
    <ng-container *ngIf="blockType === blockTypeEnum.Public">
      <button (click)="onSubmit(reponseState.draft)"
              [disabled]="submitted || isUploading()"
              color="primary"
              mat-raised-button
              matTooltip="Sauvegarder votre demande en brouillon, pour la reprendre plus tard le cas échéant"
              style="margin-right: 5px" data-cy="button-form-render-save-draft">
        Sauvegarder en tant que brouillon
      </button>
      <button (click)="onSubmit(reponseState.published)"
              [disabled]="submitted || isUploading()"
              color="accent"
              mat-raised-button
              matTooltip="Envoyer votre demande pour traitement"
              data-cy="button-form-render-send">
        Envoyer votre demande
      </button>
    </ng-container>
    <!-- le bloc administratif rempli par l'un des gestionnaires -->
    <ng-container *ngIf="blockType === blockTypeEnum.Administratif" >
      <button (click)="onSubmit(reponseState.published)"
              [disabled]="submitted || filterForm.invalid"
              color="accent"
              mat-raised-button
              matTooltip="Enregister le suivi administratif"
              data-cy="button-form-render-save-administrative-follow-up">
        Enregistrer le suivi administratif
      </button>
    </ng-container>
  </p8-layout-settings-footer>
</p8-layout-settings-page>
